export default function error(str) {
  return new Error("[FLAMELINK] ".concat(str));
}